/* eslint-disable security/detect-non-literal-fs-filename */
import React from 'react'
import { CDN } from '../../constants';

export default function RelatedDocuments({OrderData}) {
    return (
        <div className="border border-[#CBC7C7 rounded-md bg-[#F5F5FA] h-auto p-3 my-4">
            <p className="font-semibold text-base text-[#090406]">Related Documents</p>

            {OrderData && OrderData.order?.po_additional_document.length > 0 && 
            OrderData.order?.po_additional_document?.map((item,i) => (
                <div className="flex items-center justify-start" key={i}>
                    <img src="/images/red-dot.svg" alt="" />
                    <p className="ml-2 mr-3 font-normal text-base text-black">PO Document</p>
                    <div className="flex items-center" onClick={() => {
                        window.open(`${CDN}/${item}`, '_blank');
                    }}>
                        <img src="/images/download.svg" alt="icon" className="cursor-pointer" />
                        <p className="text-[#5B5B5B] text-xs3 font-semibold ml-1 cursor-pointer">Download</p>
                    </div>
                </div>
            ))||'-'}
        </div>
    )
}
